import React from 'react';
import SingleTeam from '../../../components/SingleTeam/SingleTeam';

const HomeFourTeams = () => {
    return (
        <>
            <section className="team-area pt-180 pb-65">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6 offset-xl-3 col-lg-10 offset-lg-1">
                            <div className="section-title text-center pos-rel mb-75">
                                <div className="section-icon">
                                    <img className="section-back-icon" src="img/section/section-back-icon.png" alt="" />
                                </div>
                                <div className="section-text pos-rel">
                                    <h5>Our Team</h5>
                                    <h1>A Professional & Care Provider</h1>
                                </div>
                                <div className="section-line pos-rel">
                                    <img src="img/shape/section-title-line.png" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">

                        <SingleTeam number={1} postition="MBBS, MD, DCH, FIAP, FNNF, FAMS, FICN" image="Dr. B. D. Bhatia" name="Dr. B. D. Bhatia" title="PEDIATRICS & NEONATOLOGY" />
                        <SingleTeam number={2} postition="MBBS, MS (General Surgery) FMAS, FAIS. Ex SR SMH Agra" image="Dr. S. P. Gupta" name="Dr. S. P. Gupta" title="MINIMAL ACCESS SURGERY" />
                        <SingleTeam number={3} postition="MBBS MS FMAS" image="Dr. Pramedra Singh" name="Dr. Pramedra Singh" title="MINIMAL ACCESS SURGERY" />
                        <SingleTeam number={4} postition="Surgical Oncologist | MBBS" image="Dr. Sudhendu Shekhar" name="Dr. Sudhendu Shekhar" title="SURGICAL ONCOLOGY" />
                        <SingleTeam number={5} postition="M.B.B.S., DCH (KGMU, LUCKNOW)" image="Dr. Amita Srivastava" name="Dr. Amita Srivastava" title="PEDIATRICS & NEONATOLOGY" />
                        <SingleTeam number={6} postition="M.B.B.S., DCH, PICU FELLOWSHIP, NICU FELLOWSHIP" image="Dr. Kishor Jaishi" name="Dr. Kishor Jaishi" title="PEDIATRICS & NEONATOLOGY" />
                        <SingleTeam number={7} postition="M.B.B.S., MS, MCH" image="Dr. Bal Krishna Tripati" name="Dr. Bal Krishna Tripati" title="PEDIATRICS & NEONATOLOGY" />
                        <SingleTeam number={8} postition="M.B.B.S., MD, (PEDIATRICS)" image="Dr. Renu" name="Dr. Renu" title="PEDIATRICS & NEONATOLOGY" />
                        <SingleTeam number={9} postition="M.B.B.S., M.S. (Ortho) IMS BHU" image="Dr. Sunil Kr. Singh" name="Dr. Sunil Kr. Singh" title="ORTHOPEDICS" />
                        <SingleTeam number={10} postition="M.B.B.S., DNB, D. Ortho MNAMS" image="Dr. S. Kumar Singh" name="Dr. S. Kumar Singh" title="ORTHOPEDICS" />
                        <SingleTeam number={11} postition="M.B.B.S., FGO, PGDS, Obstetrician & Gynaecologist Ex. Medical Office LBS Hospital" image="Dr. Tulika Singh" name="Dr. Tulika Singh" title="OBSTETRICS & GYANECOLOGY" />
                        <SingleTeam number={12} postition="M.B.B.S." image="Dr. Sarika Singh" name="Dr. Sarika Singh" title="OBSTETRICS & GYANECOLOGY" />
                        <SingleTeam number={13} postition="M.B.B.S., MD" image="Dr. Akhilesh Kr. Singh" name="Dr. Akhilesh Kr. Singh" title="NEUROLOGY" />
                        <SingleTeam number={14} postition="M.B.B.S., MS, MCH (NEURO)" image="Dr. Neeteesh Kr. Roy" name="Dr. Neeteesh Kr. Roy" title="NEUROLOGY" />
                        <SingleTeam number={15} postition="MBBS, MD (Radiology)" image="Dr. Sunil Dubey" name="Dr. Sunil Dubey" title="RADIOLOGY" />
                        <SingleTeam number={16} postition="M.B.B.S." image="Dr. Alka Gupta" name="Dr. Alka Gupta" title="PATHOLOGIST" />

                    </div>
                </div>
            </section>
        </>
    );
};

export default HomeFourTeams;